import { render, staticRenderFns } from "./OtherIdsEditDialog.vue?vue&type=template&id=153eca03"
import script from "./OtherIdsEditDialog.vue?vue&type=script&lang=js"
export * from "./OtherIdsEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports